import * as Telemetry from "VSS/Telemetry/Services";

export namespace TelemetryConstants {
    export const Area = "WorkItemsHub";

    // Usage scenarios
    export const CreateWorkItem = "CreateWorkItem";
    export const DeleteCommand = "DeleteCommand";
    export const TriageViewNavigation = "TriageViewNavigation";
    export const BackToWorkItemsFromTriageView = "BackToWorkItemsFromTriageView";
    export const BackToWorkItemsFromNewWorkItem = "BackToWorkItemsFromNewWorkItem";
}

/**
 * Helper for work items hub usage telemetry
 */
export namespace UsageTelemetryHelper {
    /**
     * Publish telemetry for Create New Work Item command
     * @param workItemType The work item type
     */
    export function publishCreateNewWorkItemTelemetry(workItemType: string): void {
        _publish(TelemetryConstants.CreateWorkItem, { workItemType });
    }

    /**
     * Publish telemetry for triage view navigation
     * @param tabId Tab id
     * @param fromIndex From index
     * @param toIndex To index
     * @param numberOfWorkItems Number of work items
     */
    export function publishTriageViewNavigationTelemetry(tabId: string, fromIndex: number, toIndex: number, numberOfWorkItems: number): void {
        _publish(TelemetryConstants.TriageViewNavigation, { tabId, fromIndex, toIndex, numberOfWorkItems });
    }

    /**
     * Publish telemetry for Back to Work Items from triage view command
     * @param tabId Tab id
     * @param numberOfWorkItems Number of work items
     */
    export function publishBackToWorkItemsFromTriageViewTelemetry(tabId: string, numberOfWorkItems: number): void {
        _publish(TelemetryConstants.BackToWorkItemsFromTriageView, { tabId, numberOfWorkItems });
    }

    /**
     * Publish telemetry for Back to Work Items from new work items form
     * @param tabId Tab id
     */
    export function publishBackToWorkItemsFromCreateViewTelemetry(tabId: string): void {
        _publish(TelemetryConstants.BackToWorkItemsFromNewWorkItem, { tabId });
    }

    function _publish(featureName: string, properties: IDictionaryStringTo<string | number | boolean>): void {
        Telemetry.publishEvent(new Telemetry.TelemetryEventData(TelemetryConstants.Area, featureName, properties));
    }
}
